import React, { useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useForm from 'react-hook-form';
import PropTypes from 'prop-types';
/* actions */
import { addSpecies } from '../../redux/actions/species';
/* components */
import ErrorMsgField from '../../components/ErrorMsgField';
import AlertMsg from '../../components/AlertMsg';
import FormFooter from '../../components/FormFooter';
import FormHeader from '../../components/FormHeader';
/* form-validation */
import schema from '../../form-validation/specie';
/* utils */
import handleChangeDefault from '../../utils/handleChangeDefault';

function Add (props) {
  const { handleModalClose } = props;
  const dispatch = useDispatch();
  const submitButton = useRef();
  const { register, handleSubmit, errors, reset } = useForm({
    validationSchema: schema,
    reValidateMode: 'onSubmit'
  });
  const sessionUser = useSelector(state => state.authentications.user);
  const company = sessionUser.company._id;
  const species = useSelector(state => state.species);
  const INITIAL_VALUES = {
    name: '',
    description: '',
    company
  };
  const [data, setData] = useState(INITIAL_VALUES);

  const submit = () => {
    const resetForm = () => {
      reset();
      setData({ ...INITIAL_VALUES });
    };
    dispatch(addSpecies(data, resetForm, submitButton.current));
  };

  return (
    <div className="container-fluid">
      {species.addSuccess && (
        <AlertMsg type="success" msg="Espécie cadastrada com sucesso" />
      )}
      {species.errorContent &&
        !species.errorContent.message.includes('400') &&
        species.addError && (
        <AlertMsg type="danger" msg="Falha durante cadastro da espécie" />
      )}
      {species.errorContent &&
        species.errorContent.message.includes('400') &&
        species.addError && (
        <AlertMsg
          type="danger"
          msg="Uma espécie com o nome informado já está cadastrada"
        />
      )}
      {!species.addSuccess && !species.addError && (
        <AlertMsg type="info" msg="Área cadastro de espécies" />
      )}
      <FormHeader title="Cadastrar Espécie" />
      <form onSubmit={handleSubmit(submit)}>
        <div className="form-group">
          <label htmlFor="name">
            Nome<span className="field-required">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="name"
            name="name"
            autoComplete="off"
            value={data.name}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          />
          {errors.name && errors.name.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        <div className="form-group">
          <label htmlFor="description">
            Descrição<span className="field-required">*</span>
          </label>
          <textarea
            className="form-control"
            id="description"
            name="description"
            rows="3"
            value={data.description}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          ></textarea>
          {errors.description && errors.description.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        {handleModalClose ? (
          <div className="container-fluid p-0">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleModalClose}
            >
              <i className="fa fa-times"></i>
              &nbsp;Fechar
            </button>
            <button
              type="submit"
              ref={submitButton}
              className="btn btn-primary float-right"
            >
              <i className="fa fa-save"></i>
              &nbsp;Salvar
            </button>
          </div>
        ) : (
          <FormFooter url="/species" reference={submitButton} />
        )}
      </form>
    </div>
  );
}

Add.propTypes = {
  handleModalClose: PropTypes.func
};

export default Add;
